import { CalendarDays, ConciergeBell, Flower2, Landmark, Sailboat, Waves } from "lucide-react";
import { useLang } from "../i18n";
import { Divider, Reveal } from "./Reveal";

const Places = () => {
    const { t } = useLang();
    const icons = [ConciergeBell, Waves, Sailboat, Landmark, CalendarDays, Flower2];
    return (
        <section
            data-testid="places-section"
            className="border-t border-champagne/15 bg-ivory px-5 py-20 md:px-10 md:py-24"
        >
            <Reveal className="text-center">
                <h2 className="font-serif text-2xl tracking-[0.24em] text-ink uppercase md:text-3xl">
                    {t.places.title}
                </h2>
                <div className="mt-5">
                    <Divider />
                </div>
            </Reveal>
            <div className="mx-auto mt-14 grid max-w-6xl grid-cols-2 gap-y-10 md:grid-cols-3 lg:grid-cols-6">
                {t.places.items.map((label, i) => {
                    const Icon = icons[i];
                    return (
                        <Reveal
                            key={label}
                            delay={i * 0.08}
                            className={`flex flex-col items-center gap-4 px-4 ${
                                i > 0 ? "lg:border-l lg:border-ink/10" : ""
                            }`}
                        >
                            <Icon
                                size={42}
                                strokeWidth={1}
                                className="text-champagne transition-transform duration-700 hover:-translate-y-1"
                            />
                            <span
                                data-testid={`place-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-[10px] tracking-[0.3em] text-ink/80 uppercase"
                            >
                                {label}
                            </span>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.2} className="mt-14 text-center">
                <p className="text-[10px] tracking-[0.32em] text-ink/60 uppercase md:text-[11px]">
                    {t.places.bottom}
                </p>
            </Reveal>
        </section>
    );
};

export default Places;
